import { DeviceExperience, DeviceType } from "../../device/device.model";

export enum EnvironmentType {
	Unset = "unset",
	Dev = "dev",
	Test = "test",
	Qa = "qa",
	Alpha = "alpha",
	Prod = "prod",
}

export interface EnvironmentContext {
	deviceType: DeviceType;
	deviceExperience: DeviceExperience;
	environment: EnvironmentType;
	isDebug: boolean;
	version: string;
}
